/* eslint-disable no-console */

type LEVEL = 'INFO'|'WARN'|'DEBUG'|'ERROR'|'SILENT'

const levelMapper = {
  'SILENT': 10,
  'ERROR': 9,
  'INFO': 5,
  'WARN': 2,
  'DEBUG': 0,
}

let level: LEVEL = 'INFO'

const shouldLog = (lvl: LEVEL): boolean => {
  const currentLevel = levelMapper[level]
  const desiredLevel = levelMapper[lvl]
  return desiredLevel >= currentLevel
}

const info = (...params: any) => {
  return shouldLog('INFO') && console.info(...params)
}

const warn = (...params: any) => {
  return shouldLog('WARN') && console.warn(...params)
}

const debug = (...params: any) => {
  return shouldLog('DEBUG') && console.log(...params)
}

const trace = (...params: any) => {
  return shouldLog('INFO') && console.trace(...params)
}

const error = (...params: any) => {
  return shouldLog('ERROR') && console.error(...params)
}

export const LOGGER = {
  setLevel(lvl: LEVEL) { level = lvl },
  info,
  debug,
  warn,
  trace,
  error,
}

if (process && process.env && process.env.NODE_ENV === 'test') { level = 'WARN' }
